(function () {
    'use strict';

    angular.module("imApp").factory("prodGrp3Service", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3075,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3076,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 3077,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();